import React, {Component} from 'react';
import {connect} from 'react-redux';

class Modal extends Component {
    render() {
        const {component, open} = this.props;

        const content =
            open && component ? (
                <>
                    <div className="modal-dialog">{component}</div>
                    <div className="litebox-modal"></div>
                </>
            ) : null;

        return <>{content}</>;
    }
}

function mapStatesToProps(state) {
    const {open, component} = state.modal;

    return {
        component,
        open,
    };
}

export default connect(mapStatesToProps)(Modal);
